module.exports = __webpack_public_path__ + "static/media/Brick Suit Girl.faec38af.jpg";